import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';


const BarChart = ({ xAxisData, yAxisvalue }) => {
    
    
    
  const timeSeriesWidth = window.innerWidth > 1350 ? 800 : 425;
  const timeSeriesHeight = window.innerWidth > 1350 ? 600 : 400;
  return (
    <Plot
      data={[
        {
            x: xAxisData,
            y: yAxisvalue,
            type: 'bar',
            marker: {
              color: '#EB0A1E'
            },
          }
      ]}
      layout={{
        title: 'Bar Chart For Models',
        width: timeSeriesWidth,
        height: timeSeriesHeight,
        // Adjust margin to move the heatmap to the top
        margin: {
          t: 50, // Adjust this value as needed
          l: 50,
          r: 50,
          b: 50
        },
        yaxis: {
          automargin: true,
          title: 'Count'
        },
        xaxis: {
          automargin: true,
          title: 'Models'
        },
      }}
      
      style={{ width: '100%', height: '100%' }}
    />
  );
};

BarChart.propTypes = {
    xAxisData: PropTypes.any,
    yAxisvalue: PropTypes.any,
  }

export default BarChart;
